<span class="definition-display-container container">{{definition?.displayName}}</span>
